import React from 'react'

const sizeMap = {
  SMALL: 'w-[40px] h-[40px]',
  MEDIUM: 'w-[48px] h-[48px]',
  LARGE: 'w-[56px] h-[56px]',
  XLARGE: 'w-[65px] h-[64px]',
  EXTRA_LARGE: 'w-[65px] h-[64px]', // fallback for alternate spelling
};

// Preset launcher icons from CDN
const PRESET_LAUNCHER_ICONS = [
  'https://dante-public-files.lon1.cdn.digitaloceanspaces.com/launcher_icon_1.svg',
  'https://dante-public-files.lon1.cdn.digitaloceanspaces.com/launcher_icon_2.svg',
  'https://dante-public-files.lon1.cdn.digitaloceanspaces.com/launcher_icon_3.svg',
  'https://dante-public-files.lon1.cdn.digitaloceanspaces.com/launcher_icon_4.svg'
];

// Check if image is an uploaded/custom image (not a preset icon)
const isUploadedImage = (src) => {
  if (!src || typeof src !== 'string') return false;
  // Check for data URLs or blob URLs (during preview before save)
  if (src.startsWith('data:') || src.startsWith('blob:')) return true;
  // Check if it's NOT one of the preset icons (after saved from backend)
  return !PRESET_LAUNCHER_ICONS.includes(src);
};

const LauncherPreview = ({
  launcherBackground = '#362B9D',
  launcherIcon,
  badgeCount = 0,
  showBadge = false,
  launcherSize = '',
  className = '',
  ...props
}) => {
  // Normalize launcherSize to uppercase for robustness
  const normalizedSize = (launcherSize || '').toUpperCase();
  const sizeClass = sizeMap[normalizedSize] || sizeMap.LARGE;
  const isUploaded = isUploadedImage(launcherIcon);

  return (
    <div 
      className={`${sizeClass} rounded-full ${isUploaded ? '' : 'p-3'} relative self-end mr-3 flex items-center justify-center mt-v3-ms ml-auto ${className}`}
      style={{ background: isUploaded ? 'transparent' : launcherBackground }}
      {...props}
    >
      {isUploaded ? (
        <div className="w-full h-full rounded-full overflow-hidden">
          <img 
            src={launcherIcon} 
            alt="launcher icon" 
            className="w-full h-full object-cover" 
          />
        </div>
      ) : launcherIcon ? (
        <img 
          src={launcherIcon} 
          alt="launcher icon" 
          className="max-w-full max-h-full object-contain" 
        />
      ) : (
        <img 
          src="https://dante-public-files.lon1.cdn.digitaloceanspaces.com/launcher_icon_1.svg" 
          alt="launcher icon" 
          className="max-w-full max-h-full object-contain" 
        />
      )}
      
      {showBadge && badgeCount > 0 && (
        <div className="w-6 h-6 flex items-center justify-center rounded-full text-[#fff] bg-v3-red-primary font-bold leading-5 absolute -top-1.5 -right-2">
          <p className="text-xs">{badgeCount > 99 ? '99+' : badgeCount}</p>
        </div>
      )}
    </div>
  )
}

export default LauncherPreview
